import React from 'react'

const RSVTestWorking = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4 bg-img' style={{ backgroundImage:"url('rsv-testing/ULC-Testing-bg-v1.png')", height:'100%', width:'100%'}}>
            <div className='pb-3'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    How Does an RSV Test Work?
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                A sample fluid from your nose is tested to determine if you have RSV. Several ways to collect a sample for RSV test are:
                </div>
            </div>

            <div className='pb-3'>
                <div className='fs-ss-22-2 text-montserrat text-ss-secondary fw-700'>
                    1) A Nasal Rinse or Aspirate
                </div>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                This is the most common method for collecting a sample for RSV testing. Our medical professional at United Lab Care will gently suction a saline solution (salt water) out of your nose during a nasal aspiration.
                </div>
            </div>

            <div className='pb-3'>
                <div className='fs-ss-22-2 text-montserrat text-ss-secondary fw-700'>
                    2) A Nose Swab Test
                </div>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Our specialized professional uses the nasal swab to collect a sample from your nose by a medical professional.
                </div>
            </div>

            <div className=''>
                <div className='fs-ss-15 text-montserrat fw-600 text-ss-primary' style={{ letterSpacing:'0.5px'}}>
                * Samples for the RSV test should be taken within the first few hours and days of the onset of symptoms for the accuracy of test results.
                </div>
            </div>
        </div>
    </div>
  )
}

export default RSVTestWorking